export var FieldType;
(function (FieldType) {
    FieldType["TEXT"] = "1";
    FieldType["EMAIL"] = "2";
    FieldType["PHONE"] = "3";
    FieldType["DATE"] = "4";
    FieldType["TIME"] = "5";
    FieldType["MULTILINE"] = "6";
    FieldType["RADIO"] = "7";
    FieldType["CHOICE"] = "8";
    FieldType["CHECKBOX_GROUP"] = "9";
    FieldType["DROPDOWN"] = "10";
    FieldType["MULTI_SELECT"] = "11";
    FieldType["TOGGLE"] = "12";
    FieldType["FILE"] = "13";
    FieldType["IMAGE"] = "14";
    FieldType["RATING"] = "15";
    FieldType["RANKING"] = "16";
    FieldType["NPS"] = "17";
    FieldType["COMPANYDROPDOWN"] = "18";
    FieldType["UNDERTAKING"] = "19";
    FieldType["PICKUPLOCATION"] = "20";
    FieldType["ADDITIONAL_ATTENDEES"] = "21";
})(FieldType || (FieldType = {}));
export const FIELD_TYPE_LABELS = {
    [FieldType.TEXT]: 'Text',
    [FieldType.EMAIL]: 'Email',
    [FieldType.PHONE]: 'Phone',
    [FieldType.DATE]: 'Date',
    [FieldType.TIME]: 'Time',
    [FieldType.MULTILINE]: 'Multiline',
    [FieldType.RADIO]: 'Radio',
    [FieldType.CHOICE]: 'Choice',
    [FieldType.CHECKBOX_GROUP]: 'Checkbox Group',
    [FieldType.DROPDOWN]: 'Dropdown',
    [FieldType.COMPANYDROPDOWN]: 'Company Dropdown',
    [FieldType.MULTI_SELECT]: 'Multi Select',
    [FieldType.TOGGLE]: 'Toggle',
    [FieldType.FILE]: 'File',
    [FieldType.IMAGE]: 'Image',
    [FieldType.RATING]: 'Rating',
    [FieldType.RANKING]: 'Ranking',
    [FieldType.NPS]: 'NPS',
    [FieldType.UNDERTAKING]: 'Undertaking',
    [FieldType.PICKUPLOCATION]: 'Pickup Location',
    [FieldType.ADDITIONAL_ATTENDEES]: 'Additional Attendees'
};
